import { gql } from '@apollo/client';

export const ROLE_FRAGMENT = gql`
  fragment Role on Role {
    id
    name
    isAdmin
    summaryFrequency
    permissions {
      manageResources
      canAnswerQuestions
      manageUsersAndPermissions
    }
  }
`;

const GET_ROLES = gql`
  query GetRoles($workspaceId: ID!) {
    roles(workspaceId: $workspaceId) {
      ...Role
    }
  }

  ${ROLE_FRAGMENT}
`;

export default GET_ROLES;
